import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { prettifyCardName } from '../../lib/prettifyCardName';

export const CardLogo: FC<{ cardType?: string; className?: string }> = ({
  cardType,
  className
}) => {
  const cardName = useMemo(() => prettifyCardName(cardType), [cardType]);

  if (!cardName) return null;

  return (
    <img
      className={classNames('CardLogo', className)}
      alt={cardType}
      src={`/dist/public/${cardName.toLowerCase()}.svg`}
      width={32}
      height={32}
    />
  );
};
